import React from 'react';
import styles from './style.module.css';

import facebookIcon from '../../../assets/img/icon/facebook-icon.svg';
import twitterIcon from '../../../assets/img/icon/twitter-icon.svg';
import instagramIcon from '../../../assets/img/icon/instagram-icon.svg';
import youtubeIcon from '../../../assets/img/icon/youtube-icon.svg';
import linkedinIcon from '../../../assets/img/icon/linkedin-icon.svg';

export default function Footer() {
  const footerGroup = [
    {
      id: 1,
      title: 'OUR WEBSITE',
      menus: ['Kebijakan Privasi', 'Waspada Penipuan'],
    },
    {
      id: 2,
      title: 'TOOLS',
      menus: ['TKO', 'TKI', 'STK', 'Dokumen'],
    },
    {
      id: 3,
      title: 'ANNOUNCEMENT',
      menus: [
        'Pertamina Info',
        'Pengadaan Umum',
        'Pengumuman',
        'E-Procurement',
      ],
    },
    {
      id: 4,
      title: 'NETWORK',
      menus: ['Anak Perusahaan', 'Alamat Kantor'],
    },
  ];

  return (
    <div className={styles.root}>
      <div className={styles.footerWrapper}>
        <div className={styles.leftFooter}>
          {footerGroup.map((item) => (
            <div key={`footer-menu-${item.id}`} className={styles.column}>
              <h2 className={styles.title}>{item.title}</h2>
              <ul className={styles.menuList}>
                {item.menus.map((menu, index) => (
                  <li key={`footer-menu-${index}`}>
                    <a href="#">{menu}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className={styles.rightFooter}>
          <h2>CONTACT</h2>
          <span className={styles.number}>135</span>
          <p>Address : Jl. Medan Merdeka Timur 1A, Jakarta 10110</p>
          <p>Email : pcc135@pertamina.com</p>
          <div className={styles.socialMedia}>
            <ul>
              <li>
                <a href="https://www.facebook.com">
                  <img src={facebookIcon} alt="Facebook Icon" />
                </a>
              </li>
              <li>
                <a href="https://www.twitter.com">
                  <img src={twitterIcon} alt="Twitter Icon" />
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com">
                  <img src={instagramIcon} alt="Instagram Icon" />
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com">
                  <img src={youtubeIcon} alt="Youtube Icon" />
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com">
                  <img src={linkedinIcon} alt="LinkedIn Icon" />
                </a>
              </li>
            </ul>
            <span>@pertamina</span>
          </div>
        </div>
      </div>
      <hr className={styles.footer} />
      <span className={styles.copy}>
        Copyrights PT Pertamina (Persero) 2022. <span>All Rights Reserved</span>
      </span>
    </div>
  );
}
